export enum Zone {
  high = "high",
  low = "low",
}
